angular
    .module('WizApp')
    .config([
        'tagsInputConfigProvider',
        '$interpolateProvider',
        '$httpProvider',
        '$compileProvider',
        '$animateProvider',
        '$locationProvider',
        function (tagsInputConfigProvider, $interpolateProvider, $httpProvider, $compileProvider, $animateProvider, $locationProvider) {
            // Configure tags-input
            if (!tagsInputConfigProvider.mocked) {
                tagsInputConfigProvider
                    .setDefaults('tagsInput', {
                        placeholder: '',
                        minLength: 1,
                        addOnSpace: false,
                        addOnComma: true,
                        displayProperty: 'name',
                        replaceSpacesWithDashes: false,
                        allowLeftoverText: true
                    })
                    .setDefaults('autoComplete', {
                        selectFirstMatch: false,
                        debounceDelay: 200,
                        template: 'ngTagsInput/custom/auto-complete-match.html'
                    })
                ;
            }

            // Avoid conflict with twig by using {[ variable ]} instead of {{ variable }}
            $interpolateProvider
                .startSymbol('{[')
                .endSymbol(']}')
            ;

            // Make $http.post() behave like $.post
            $httpProvider.defaults.transformRequest = function (data) {
                return angular.isDefined(data) ? $.param(data) : data;
            };

            $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';

            $httpProvider.interceptors.push('HttpRequestTimeInterceptor');

            // add support to skype urls (skype:username)
            $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|skype):/);

            // https://docs.angularjs.org/guide/production
            $compileProvider.debugInfoEnabled(false);

            // animation must be explicitly enabled
            const animatableClasses = [
                'lightbox',
                'mail-alert__item__detail',
                'animatable',
                'animate-transition'
            ];
            const animatableRegexp = new RegExp(`(^|\\s)(${animatableClasses.join('|')})(\\s|$)`);
            $animateProvider.classNameFilter(animatableRegexp);

            $locationProvider.html5Mode({
                enabled: true,
                requireBase: false,
                rewriteLinks: false
            });
        }
    ])
    .run([
        'UserService',
        '$templateCache',
        'BugReporter',
        '$window',
        'AnalyticsService',
        'TrackerService',
        function (UserService, $templateCache, BugReporter, $window, AnalyticsService, TrackerService) {
            // Get the logged user's data
            UserService.get();

            $templateCache.put(
                'ngTagsInput/custom/auto-complete-match.html',
                '<span>' +
                    '<span ng-if="data._id == null">{[ "wizbii.core.messages.action.addtag"|trans ]} "{[ $getDisplayText() ]}"</span>' +
                    '<span ng-if="data._id != null" ng-bind-html="$highlight($getDisplayText())"></span>' +
                '</span>'
            );

            if (angular.isObject($window._wizData)) {
                let user = _.pick($window._wizData.UserSession, ['slug', 'first_name', 'last_name', 'email']);
                let releaseStage = $window._wizData.environment === 'prod' ? 'production' : 'development';
                BugReporter.addMetas({ user, releaseStage });
            }

            AnalyticsService.addService(TrackerService);
        }
    ])
    .run([
        '$window',
        '$rootScope',
        function ($window, $rootScope) {
            $window.__bridge__ = {
                setSubmitPublicationDisabler(callback) {
                    $rootScope.$on('discovery:openDialog', (event, id) => {
                        if (id !== '#discovery-submit-publication') {
                            return;
                        }

                        callback();
                    });
                },

                setSubmitPublicationEnabler(callback) {
                    $rootScope.$on('discovery:validate', (event, id) => {
                        if (id !== '#discovery-submit-publication') {
                            return;
                        }

                        callback();
                    });
                },

                submitPublicationRequest({ content, mentions, tags, attachment }, poster) {
                    const publication = {
                        content,
                        mentions,
                        tags,
                        poster,
                        posterType: poster.posterType,
                        [poster.posterType.toLowerCase()]: poster,
                        type: 'SHARE',
                        draft: true
                    };

                    if (attachment) {
                        _.assign(publication, {
                            attachment_content: attachment.description,
                            attachment_link: attachment.absolute_src,
                            attachment_title: attachment.title
                        });

                        if (attachment.image) {
                            _.assign(publication, {
                                attachment_picture: attachment.image.absolute_src,
                                attachment_picture_width: attachment.image.size.width,
                                attachment_picture_height: attachment.image.size.height
                            });
                        }
                    }

                    $rootScope.$emit('publication.submit', publication);
                },

                submitPublicationSuccess() {
                    $rootScope.$emit('publication.update');
                }
            };
        }
    ])
;
